import { __extends } from "tslib";
import { deserializeAws_restXmlListObjectsV2Command, serializeAws_restXmlListObjectsV2Command } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListObjectsV2Command = /** @class */ (function (_super) {
    __extends(ListObjectsV2Command, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListObjectsV2Command(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListObjectsV2Command.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListObjectsV2Command.prototype.serialize = function (input, context) {
        return serializeAws_restXmlListObjectsV2Command(input, context);
    };
    ListObjectsV2Command.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlListObjectsV2Command(output, context);
    };
    return ListObjectsV2Command;
}($Command));
export { ListObjectsV2Command };
//# sourceMappingURL=ListObjectsV2Command.js.map